import constants from './constants';

export default {
    isEmpty(value) {
        if (value === null || value === undefined) return true;

        if (typeof(value) === 'number') return false;

        if (typeof(value) === 'string') return value.match(/^ *$/) !== null;

        if (Array.isArray(value)) return value.length === 0;

        if (value instanceof Date) return false;

        if (typeof(value) === 'object') return Object.keys(value).length === 0;

        return false;
    },
    isEmptyOrZero(value) {
        if (this.isEmpty(value)) return true;

        if (typeof(value) === 'string') return value.match(/^0*$/) !== null;

        if (typeof(value) === 'number' && value === 0) return true;

        return false;
    },
    isNumeric(value) {
        return /^\d{0,15}([,.]\d{1,2})*$/.test(value.toString());
    },

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            /* eslint-disable no-bitwise */
            const r = Math.random() * 16 | 0;
            /* eslint-disable no-bitwise, no-mixed-operators */
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    splitAtDelimiters(value) {
        if (this.isEmpty(value)) return value;

        return value.split(/[\s;,]+/);
    },
    filterMultiple(array, filters, callback) {
        if (this.isEmpty(array) || this.isEmpty(filters)) return array;

        let filteredArray = array;
        const filterPieces = this.splitAtDelimiters(filters);

        filterPieces.forEach((filter) => {
            if (!this.isEmpty(filter)) {
                const regex = new RegExp(filter.trim(), 'i');
                filteredArray = filteredArray.filter(item => callback(item, regex));
            }
        });

        return filteredArray;
    },

    mimeApplicationToFontAwesome(mime) {
        if (this.isEmpty(mime)) return 'fa-file-o';

        if (mime.includes('excel') || mime.includes('.sheet')) return 'fa-file-excel-o';

        if (mime.includes('powerpoint') || mime.includes('.presentation')) return 'fa-file-powerpoint-o';

        if (mime.includes('word') || mime.includes('.document')) return 'fa-file-word-o';

        if (mime.includes('javascript')) return 'fa-file-code-o';

        if (mime.includes('pdf')) return 'fa-file-pdf-o';

        if (mime.includes('compressed')) return 'fa-file-archive-o';

        return 'fa-file-o';
    },
    mimeToFontAwesome(mime) {
        if (this.isEmpty(mime)) return 'fa-file-o';

        const [prefix, sufix] = mime.split('/');

        const hash = {
            image: 'fa-file-image-o',
            audio: 'fa-file-audio-o',
            video: 'fa-file-video-o',
            application: this.mimeApplicationToFontAwesome(sufix),
            text: 'fa-file-text-o',
        };

        return hash[prefix];
    },
    fontAwesomeFileIconToClass(icon) {
        if (this.isEmpty(icon)) return 'grey--text text--darken-1';

        const hash = {
            'fa-file-image-o': 'purple--text text--darken-2',
            'fa-file-audio-o': 'purple--text text--darken-2',
            'fa-file-excel-o': 'green--text text--darken-2',
            'fa-file-powerpoint-o': 'amber--text text--darken-3',
            'fa-file-word-o': 'blue--text text--darken-4',
            'fa-file-text-o': 'blue--text text--darken-4',
            'fa-file-pdf-o': 'red--text text--darken-4',
            'fa-file-archive-o': 'brown--text text--darken-1',
        };

        return hash[icon] || 'grey--text text--darken-1';
    },

    splitFileNameExtension(fileName) {
        if (this.isEmpty(fileName)) return ['', ''];

        const index = fileName.lastIndexOf('.');

        if (index <= 0) return [fileName, ''];

        const name = fileName.substr(0, index);
        const extension = fileName.substr(index + 1);

        return [name, extension];
    },

    numberToDataString(value) {
        return Math.ceil(value).toLocaleString('en-us', { maximumFractionDigits: 0 });
    },

    filterByStatus(array, ...status) {
        if (this.isEmpty(array)) return [];

        return array.filter(item => status.some(status => status === item.status.id));
    },
    acumulateFiles(workflowHistory, status) {
        if (this.isEmptyOrZero(workflowHistory)) return [];

        const items = this.filterByStatus(workflowHistory, status);
        const files = items.reduce((arr, obj) => [...arr, ...obj.files], []);

        return files.sort((a, b) => a.id - b.id);
    },

    isApprovalOrRejectionStatus(value) {
        const status = [
            constants.STATUS_CREATED_APPROVAL,
            constants.STATUS_PLANNING_APPROVAL,
            constants.STATUS_DELIVERY_APPROVAL,
            constants.STATUS_REJECTED,
            constants.STATUS_FINALIZING,
        ];

        return status.includes(value);
    },
    isDemandActionable(user, person, status, value, exact = true) {
        // Admins can always do anything
        if (user.isAdmin) return true;

        // No status, can't be actioned
        if (this.isEmpty(status)) return false;

        // No reference person, can't be actioned
        if (this.isEmpty(person)) return false;

        // Only the person specified can change it
        if (person.id !== user.person.id) return false;

        // No value given for comparison, can be actioned if it exists (status > 0)
        if (this.isEmptyOrZero(value)) return !this.isEmptyOrZero(status.id);

        // Make the comparison
        return exact ? status.id === value : status.id <= value;
    },

    stringCompare(a, b) {
        const aUpper = a.toUpperCase().trim();
        const bUpper = b.toUpperCase().trim();

        if (aUpper < bUpper) return -1;
        if (aUpper > bUpper) return 1;
        return 0;
    },
    padStart(value, targetLength, padString) {
        targetLength >>= 0;
        padString = String(padString || ' ');
        if (value.length > targetLength) {
            return String(this);
        }

        targetLength -= value.length;
        if (targetLength > padString.length) {
            padString += padString.repeat(targetLength / padString.length);
        }
        return padString.slice(0, targetLength) + String(value);
    },
    toMoney(val) {
        return Number(val).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    toNumber(val) {
        return Number(val.toString().replace(',', '.'));
    },
    toFixedFloat(val, precision = 2) {
        const numberString = val.toString().replace(',', '.');
        const hasDecimal = numberString.indexOf('.') > 0;
        const number = this.toNumber(numberString.replace(/\D+/g, ''));
        const exp = 10 ** ((numberString.length - 1) - numberString.indexOf('.'));
        const value = hasDecimal ? parseFloat(number) / exp : parseFloat(numberString);
        return parseFloat(value).toFixed(precision);
    },
    toDate(val) {
        return new Date(val).toLocaleDateString('pt-BR');
    },
    toTime(val) {
        return new Date(val).toLocaleTimeString('pt-BR');
    },
    toDateTime(val) {
        return [this.toDate(val), this.toTime(val)].join('_');
    },
    clone(obj, base = {}) {
        return Object.assign(base, JSON.parse(JSON.stringify(obj)));
    },
    toForm(obj, base = {}) {
        const clone = this.clone(obj, base);

        Object.keys(clone).forEach((key) => {
            const property = clone[key];
            if (Array.isArray(property)) {
                property.forEach((item) => { item.uuid = this.uuidv4(); });
            }
        });

        return clone;
    },
    toPayload(obj) {
        const clone = this.clone(obj);

        // To avoid problems with the API, remove from the
        // payload any nested object that constains only the
        // ID property and it's empty or Zero, or any properties
        // that are empty collections.
        Object.keys(clone).forEach((key) => {
            const property = clone[key];

            if (!property) return;

            if (typeof(property) !== 'object') return;

            if (Array.isArray(property) && property.length > 0) return;

            if (property instanceof Date) return;

            if (Object.keys(property).length > 1) return;

            if (!this.isEmptyOrZero(property.id)) return;

            clone[key] = null;
        });

        return clone;
    },

    combobox(arr, id) {
        return arr.filter(item => item.isActive || item.value === id);
    },
};


// WEBPACK FOOTER //
// ./src/helpers/utilities.js